import { render, staticRenderFns } from "./Effectiveness.vue?vue&type=template&id=511a57d7&"
import script from "./Effectiveness.vue?vue&type=script&lang=ts&"
export * from "./Effectiveness.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports